export var supportedCutoffCategories = [
    'normal',
    'mild to moderate',
    'severe',
];
